import React from "react";
import "./styles.scss";
import Dropdown from "react-bootstrap/Dropdown";

const CalendarDownload: React.FC<any> = ({
  calendarTitle,
  calendarOptions,
  calendarTrackingId,
}) => {
  const listItems = calendarOptions.map((item: any, i: number) =>
    <Dropdown.Item
      target="_blank"
      key={i}
      rel="noopener noreferrer"
      data-attr="calendar_content_item"
      id={`${calendarTrackingId}:add-to-${item.calendar}`}
      tracking-id={`${calendarTrackingId}:add-to-${item.calendar}`}
      tracking-type="download"
      href={item.url}>{item.calendar}</Dropdown.Item>
  );
  return (
   <>
    <Dropdown>
      <Dropdown.Toggle
        className="calendarSelect"
        id={`${calendarTrackingId}:dropdown`}
        tracking-id={`${calendarTrackingId}:dropdown`}
        tracking-type="other">
        {calendarTitle}
      </Dropdown.Toggle>
      <Dropdown.Menu className="calendarOptionItems">
        {listItems}
      </Dropdown.Menu>
    </Dropdown>
  </>
  );
}

export default CalendarDownload;
